var background = "https://shopfront-cdn.tekoapis.com/static/518d97d5f0c97081.svg";

export { background as default };
